import PropTypes from 'prop-types';
import { Inline, Stack, Text, Tooltip, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { CarrierBookingNumber } from '@eti/types';
import { InformationIconButton } from '@eti/components';
import { constants } from '@eti/utils';

const blueBoxStyles = css`
  background: ${vars.colors.signal.information.tint};
  border: 1px solid ${vars.colors.signal.information.light};
  border-radius: 3px;
  padding: 8px;
  width: fit-content;
  word-break: break-word;
`;

const CheckinInfoBox = ({
  carrierBookingNumber: { bookingNumber, carrierCode, carrierName },
  customerEmail,
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      className={blueBoxStyles}
      data-testid={`self-checkin-${bookingNumber}-${carrierCode}`}
      spacing={8}
    >
      <div data-testid={`self-checkin-${bookingNumber}-${carrierCode}-airline`}>{carrierName}</div>
      <Inline
        data-testid={`self-checkin-${bookingNumber}-${carrierCode}-booking-number`}
        spacing={4}
      >
        {t('OrderDetails.CheckIn.Self.Bound.BookingNumber.Text')}{' '}
        {bookingNumber ? (
          <strong className={constants.MOUSE_FLOW_CLASS_NAMES}>{bookingNumber}</strong>
        ) : (
          <Inline data-testid={`unavailable-booking-number-${carrierCode}`} noWrap spacing={4}>
            <Text>{t('CheckIn.ReferenceNo.Unavailable.Text')}</Text>
            <Tooltip content={t('OrderDetails.Airlines.BookingNumber.Unavailable.Text')}>
              <InformationIconButton data-testid="unavailable-info-icon" />
            </Tooltip>
          </Inline>
        )}
      </Inline>
      <div
        className={constants.MOUSE_FLOW_CLASS_NAMES}
        data-testid={`self-checkin-${bookingNumber}-${carrierCode}-email`}
      >
        {t('OrderDetails.CheckIn.Self.Bound.Email.Text')} {customerEmail}
      </div>
    </Stack>
  );
};

CheckinInfoBox.propTypes = {
  carrierBookingNumber: CarrierBookingNumber,
  customerEmail: PropTypes.string,
};

export default CheckinInfoBox;
